export const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  // Explicit timeZone so this always renders in IST regardless of the viewer's
  // browser/OS clock — dates are stored as absolute UTC instants; only display
  // should be timezone-pinned.
  return date.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "Asia/Kolkata",
  });
};
